import { ProposalActions, ProposalTypes } from './proposal.action';
import { GetOrderResponse, Application } from '@codegen';

export class ProposalState {
  public proposalsList: Application[];
  public isNeedConfirmation: boolean;
  public proposalDetails: Application | GetOrderResponse = null;
  public activeRouteLink: string;
}

export function reducer(
  state = new ProposalState(),
  action: ProposalActions
): ProposalState {
  switch (action.type) {
    case ProposalTypes.SetProposalList:
      return {
        ...state,
        proposalsList: action.payload,
      };
    case ProposalTypes.SetIsNeedConfirmation:
      return {
        ...state,
        isNeedConfirmation: action.payload,
      };
    case ProposalTypes.SetProposalDetails:
      return {
        ...state,
        proposalDetails: action.payload,
      };
    case ProposalTypes.SetActiveProposalRouteLink:
      return {
        ...state,
        activeRouteLink: action.payload,
      };
    default: {
      return state;
    }
  }
}
